import { Routes, Route, Navigate, useLocation, Outlet } from 'react-router-dom'

import usePermission from './util/usePermission'
import ClaimApprovalCenterOverview from './view/overview/ClaimApprovalCenterOverview'
import LeaveApprovalCenterOverview from './view/overview/LeaveApprovalCenterOverview'
import ClaimApprovalRequest from './view/singleRequest/ClaimApprovalRequest'
import LeaveApprovalRequest from './view/singleRequest/LeaveApprovalRequest'
import UpskillApprovalCenterOverview from './view/overview/UpskillApprovalCenterOverview'
import ClaimReimbursementRoutes from 'pages/reimbursement-center/routes'
import ReimbursementOverview from 'pages/reimbursement-center/pages/ReimbursementOverview'

const ApprovalCenterRoutes = () => {
  const location = useLocation()
  const state = location.state
  const { isFinance } = usePermission()

  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route index element={<Navigate to="claim" />} />
        <Route path="claim" element={<Outlet />}>
          <Route index element={<Navigate to="pending" />} />
          <Route
            path="pending"
            element={<ClaimApprovalCenterOverview initialTab={0} module="claim" />}
          />
          <Route
            path="upcoming"
            element={<ClaimApprovalCenterOverview initialTab={1} module="claim" />}
          />
          <Route
            path="responded"
            element={<ClaimApprovalCenterOverview initialTab={2} module="claim" />}
          />
          {isFinance && (
            <Route
              path="reimbursement"
              element={<ClaimApprovalCenterOverview initialTab={3} module="claim" />}
            />
          )}
          <Route path="*" element={<Navigate to="/app/approval-center/claim/pending" />} />
        </Route>
        <Route path="leave" element={<Outlet />}>
          <Route index element={<Navigate to="pending" />} />
          <Route
            path="pending"
            element={<LeaveApprovalCenterOverview initialTab={0} module="leave" />}
          />
          <Route
            path="upcoming"
            element={<LeaveApprovalCenterOverview initialTab={1} module="leave" />}
          />
          <Route
            path="responded"
            element={<LeaveApprovalCenterOverview initialTab={2} module="leave" />}
          />
          <Route
            path="summary"
            element={<LeaveApprovalCenterOverview initialTab={3} module="leave" />}
          />
          {/* <Route
            path="completed"
            element={<LeaveApprovalCenterOverview initialTab={3} module="leave" />}
          /> */}
        </Route>
        <Route path="upskill" element={<Outlet />}>
          <Route index element={<Navigate to="pending" />} />
          <Route
            path="pending"
            element={<UpskillApprovalCenterOverview initialTab={0} module="upskill" />}
          />
          <Route
            path="approved"
            element={<UpskillApprovalCenterOverview initialTab={1} module="upskill" />}
          />
          <Route
            path="rejected"
            element={<UpskillApprovalCenterOverview initialTab={2} module="upskill" />}
          />
        </Route>

        {/* <Route path="reimbursement/*" element={<ClaimReimbursementRoutes />} /> */}
        <Route path="reimbursement" element={<Outlet />}>
          <Route index element={<Navigate to="pending" />} />
          <Route path="pending" element={<ReimbursementOverview initialTab={0} />} />
          <Route path="downloaded" element={<ReimbursementOverview initialTab={1} />} />
          <Route path="reimbursed" element={<ReimbursementOverview initialTab={2} />} />
        </Route>

        <Route path="*" element={<Navigate to="claim" />} />
      </Routes>
      {state?.backgroundLocation && (
        <Routes>
          <Route path={'claim/request'} element={<Outlet />}>
            <Route path=":id" element={<ClaimApprovalRequest data={state?.data} />} />
          </Route>
          <Route path={'leave/request'} element={<Outlet />}>
            <Route path=":id" element={<LeaveApprovalRequest data={state?.data} />} />
          </Route>
          <Route path={'reimbursement/request'} element={<Outlet />}>
            <Route path=":id" element={<ClaimApprovalRequest data={state?.data} />} />
          </Route>
        </Routes>
      )}
    </>
  )
}

export default ApprovalCenterRoutes
